import { useReveal } from '../hooks/useReveal';

function EstateSmartViz() {
  return (
    <svg
      className="ca-sol-viz ca-sol-viz--estate"
      viewBox="0 0 248 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      {/* Flow spine + marching dashes */}
      <path
        className="ca-estate-flow__spine"
        d="M 58 64 L 70 64 L 108 64 L 120 64 L 158 64 L 170 64 L 208 64"
        stroke="rgba(71,85,105,0.45)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="ca-estate-flow__spine ca-estate-flow__spine--pulse"
        d="M 58 64 L 208 64"
        stroke="rgba(248,113,113,0.55)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray="6 10"
      />
      <g className="ca-estate-flow__runner-wrap">
        <circle className="ca-estate-flow__runner" cx="0" cy="0" r="4" fill="#f87171" />
      </g>

      {/* 1 — Homes & units registry */}
      <g transform="translate(20 34)">
        <g className="ca-estate-flow__node-inner ca-estate-flow__node-inner--1">
          <rect width="40" height="58" rx="8" fill="rgba(18,18,28,0.95)" stroke="rgba(248,113,113,0.35)" strokeWidth="1.2" />
          <path
            className="ca-estate-flow__icon"
            d="M8 42 L20 30 L32 42 V50H8V42Z"
            fill="rgba(248,113,113,0.2)"
            stroke="rgba(248,113,113,0.75)"
            strokeWidth="1"
            strokeLinejoin="round"
          />
          <path
            d="M22 42 L30 36 L38 42 V50H22V42Z"
            fill="rgba(248,113,113,0.12)"
            stroke="rgba(248,113,113,0.45)"
            strokeWidth="0.8"
            strokeLinejoin="round"
          />
          <text x="20" y="24" textAnchor="middle" fill="rgba(248,113,113,0.85)" fontSize="7" fontFamily="system-ui, sans-serif">
            Homes
          </text>
        </g>
      </g>

      {/* 2 — Dues & levies */}
      <g transform="translate(70 34)">
        <g className="ca-estate-flow__node-inner ca-estate-flow__node-inner--2">
          <rect width="40" height="58" rx="8" fill="rgba(18,18,28,0.95)" stroke="rgba(248,113,113,0.35)" strokeWidth="1.2" />
          <text x="20" y="24" textAnchor="middle" fill="rgba(248,113,113,0.85)" fontSize="7" fontFamily="system-ui, sans-serif">
            Dues
          </text>
          <line x1="10" y1="40" x2="30" y2="40" stroke="rgba(148,163,184,0.5)" strokeWidth="1.5" strokeLinecap="round" />
          <line x1="10" y1="46" x2="26" y2="46" stroke="rgba(148,163,184,0.35)" strokeWidth="1.5" strokeLinecap="round" />
          <circle cx="30" cy="52" r="5" fill="rgba(250,204,21,0.15)" stroke="rgba(250,204,21,0.65)" strokeWidth="1" />
          <path d="M27 52h6M30 49v6" stroke="rgba(250,204,21,0.8)" strokeWidth="0.9" strokeLinecap="round" />
        </g>
      </g>

      {/* 3 — Guest clearance code */}
      <g transform="translate(120 34)">
        <g className="ca-estate-flow__node-inner ca-estate-flow__node-inner--3">
          <rect width="40" height="58" rx="8" fill="rgba(18,18,28,0.95)" stroke="rgba(248,113,113,0.35)" strokeWidth="1.2" />
          <text x="20" y="22" textAnchor="middle" fill="rgba(248,113,113,0.85)" fontSize="6.5" fontFamily="system-ui, sans-serif">
            Guest code
          </text>
          <g stroke="rgba(148,163,184,0.45)" strokeWidth="0.9">
            {[0, 1, 2].flatMap((row) =>
              [0, 1, 2].map((col) => (
                <rect
                  key={`${row}-${col}`}
                  x={10 + col * 7}
                  y={30 + row * 7}
                  width="5"
                  height="5"
                  rx="0.8"
                  fill="rgba(248,113,113,0.12)"
                />
              ))
            )}
          </g>
          <g className="ca-estate-flow__pin" fill="rgba(248,113,113,0.9)">
            <circle cx="14" cy="54" r="1.6" />
            <circle cx="20" cy="54" r="1.6" />
            <circle cx="26" cy="54" r="1.6" />
          </g>
        </g>
      </g>

      {/* 4 — Gate / access granted */}
      <g transform="translate(170 34)">
        <g className="ca-estate-flow__node-inner ca-estate-flow__node-inner--4">
          <rect width="40" height="58" rx="8" fill="rgba(18,18,28,0.95)" stroke="rgba(248,113,113,0.35)" strokeWidth="1.2" />
          <text x="20" y="24" textAnchor="middle" fill="rgba(248,113,113,0.85)" fontSize="7" fontFamily="system-ui, sans-serif">
            Gate
          </text>
          <path
            d="M12 48 V38 M28 48 V38"
            stroke="rgba(248,113,113,0.55)"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            className="ca-estate-flow__gate-arm"
            d="M12 38 Q20 32 28 38"
            stroke="rgba(74,222,128,0.75)"
            strokeWidth="1.8"
            fill="none"
            strokeLinecap="round"
          />
          <path
            className="ca-estate-flow__gate-ok"
            d="M16 50 L20 54 L26 46"
            stroke="#4ade80"
            strokeWidth="1.8"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
}

function AccountingViz() {
  return (
    <svg className="ca-sol-viz ca-sol-viz--account" viewBox="0 0 200 180" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <line x1="36" y1="140" x2="164" y2="140" stroke="rgba(148,163,184,0.35)" strokeWidth="1" />
      <rect className="ca-sol-viz__bar" x="44" y="96" width="20" height="44" rx="2" fill="rgba(96,165,250,0.35)" stroke="rgba(96,165,250,0.6)" strokeWidth="0.8" />
      <rect className="ca-sol-viz__bar" x="76" y="72" width="20" height="68" rx="2" fill="rgba(96,165,250,0.45)" stroke="rgba(96,165,250,0.7)" strokeWidth="0.8" />
      <rect className="ca-sol-viz__bar" x="108" y="84" width="20" height="56" rx="2" fill="rgba(96,165,250,0.4)" stroke="rgba(96,165,250,0.65)" strokeWidth="0.8" />
      <rect className="ca-sol-viz__bar" x="140" y="56" width="20" height="84" rx="2" fill="rgba(96,165,250,0.5)" stroke="rgba(147,197,253,0.85)" strokeWidth="0.8" />
      <path
        className="ca-sol-viz__trend"
        d="M40 118 L70 100 L100 108 L130 78 L160 62"
        stroke="rgba(248,113,113,0.7)"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="8 6"
      />
    </svg>
  );
}

function BookkeepingViz() {
  return (
    <svg className="ca-sol-viz ca-sol-viz--books" viewBox="0 0 200 180" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <rect className="ca-sol-viz__doc ca-sol-viz__doc--back" x="56" y="48" width="88" height="100" rx="6" fill="rgba(30,41,59,0.9)" stroke="rgba(148,163,184,0.35)" strokeWidth="1" />
      <rect className="ca-sol-viz__doc ca-sol-viz__doc--mid" x="48" y="56" width="88" height="100" rx="6" fill="rgba(30,41,59,0.95)" stroke="rgba(148,163,184,0.45)" strokeWidth="1" />
      <rect className="ca-sol-viz__doc ca-sol-viz__doc--front" x="40" y="64" width="88" height="100" rx="6" fill="rgba(18,24,38,0.98)" stroke="rgba(74,222,128,0.4)" strokeWidth="1.2" />
      <line x1="56" y1="88" x2="112" y2="88" stroke="rgba(148,163,184,0.25)" strokeWidth="2" strokeLinecap="round" />
      <line x1="56" y1="100" x2="104" y2="100" stroke="rgba(148,163,184,0.2)" strokeWidth="2" strokeLinecap="round" />
      <path className="ca-sol-viz__check ca-sol-viz__check--1" d="M58 124 L72 138 L96 112" stroke="#4ade80" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <path className="ca-sol-viz__check ca-sol-viz__check--2" d="M104 124 L118 138 L142 112" stroke="#86efac" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function SalesViz() {
  return (
    <svg className="ca-sol-viz ca-sol-viz--sales" viewBox="0 0 200 180" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <rect x="32" y="44" width="136" height="100" rx="8" fill="rgba(18,18,28,0.6)" stroke="rgba(248,113,113,0.2)" strokeWidth="1" />
      <path
        className="ca-sol-viz__sales-line"
        d="M52 128 L78 96 L104 108 L130 72 L156 52"
        stroke="url(#caSolSalesGrad)"
        strokeWidth="2.5"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="10 8"
      />
      <defs>
        <linearGradient id="caSolSalesGrad" x1="0%" y1="100%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#dc2626" stopOpacity="0.6" />
          <stop offset="100%" stopColor="#f87171" stopOpacity="1" />
        </linearGradient>
      </defs>
      <circle className="ca-sol-viz__sales-dot ca-sol-viz__sales-dot--a" cx="52" cy="128" r="5" fill="#f87171" />
      <circle className="ca-sol-viz__sales-dot ca-sol-viz__sales-dot--b" cx="104" cy="108" r="4" fill="#fecaca" />
      <circle className="ca-sol-viz__sales-dot ca-sol-viz__sales-dot--c" cx="156" cy="52" r="6" fill="#ef4444" />
      <rect className="ca-sol-viz__pipe" x="44" y="136" width="112" height="8" rx="4" fill="rgba(248,113,113,0.08)" stroke="rgba(248,113,113,0.25)" strokeWidth="0.8" />
      <g className="ca-sol-viz__pipe-g" transform="translate(46 138)">
        <rect className="ca-sol-viz__pipe-fill" width="108" height="4" rx="2" fill="rgba(220,38,38,0.6)" />
      </g>
    </svg>
  );
}

const solutions = [
  {
    key: 'estate',
    title: 'Estate security & smart cities',
    body:
      'One connected flow: homes and units stay organized in a central registry, service charges and dues are tracked and settled, visitors receive time-bound clearance codes, and gates or barriers open only after validation—built for estates and smart-city style campuses.',
    Viz: EstateSmartViz,
  },
  {
    key: 'accounting',
    title: 'Accounting platforms',
    body:
      'General ledger, multi-entity books, tax-ready reporting, and integrations with banks and regulators—accuracy your finance team can audit with confidence.',
    Viz: AccountingViz,
  },
  {
    key: 'bookkeeping',
    title: 'Bookkeeping systems',
    body:
      'Day-to-day records, reconciliations, invoicing hooks, and clean handoffs to accountants—less manual work, fewer errors, clearer cash visibility.',
    Viz: BookkeepingViz,
  },
  {
    key: 'sales',
    title: 'Sales & enterprise operations',
    body:
      'CRM pipelines, order-to-cash workflows, inventory touchpoints, and leadership dashboards—keeping revenue teams aligned and the business running without friction.',
    Viz: SalesViz,
  },
];

export default function IndustrySolutions() {
  const [ref, visible] = useReveal();

  return (
    <section id="verticals" className="ca-section ca-section--verticals" ref={ref} data-analytics-section="verticals">
      <div className="ca-container">
        <header className={`ca-section-head ca-verticals__head ca-reveal ${visible ? 'ca-reveal--visible' : ''}`}>
          <p className="ca-eyebrow">Business &amp; civic</p>
          <h2 className="ca-section-title">Solutions that keep estates secure and businesses running</h2>
          <p className="ca-section-lead ca-verticals__intro">
            Beyond core software delivery, we build and integrate platforms for{' '}
            <strong>estate security and smart-city style operations</strong>, full{' '}
            <strong>accounting</strong> suites, disciplined <strong>bookkeeping</strong>, and{' '}
            <strong>sales &amp; enterprise</strong> tooling—so security, finance, and revenue engines stay
            reliable day to day.
          </p>
        </header>

        <ul className="ca-verticals-grid">
          {solutions.map((s, i) => {
            const V = s.Viz;
            return (
              <li
                key={s.key}
                className={`ca-verticals-card ca-reveal ${visible ? 'ca-reveal--visible' : ''}`}
                style={{ transitionDelay: `${90 + i * 75}ms` }}
              >
                <div className={`ca-verticals-card__viz ca-verticals-card__viz--${s.key}`}>
                  <V />
                </div>
                <h3 className="ca-verticals-card__title">{s.title}</h3>
                <p className="ca-verticals-card__body">{s.body}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
